import React from 'react';
import { IconTags } from '@tabler/icons';
import SimpleLookupCrud from './SimpleLookupCrud';

const FinancialCategories = () => (
    <SimpleLookupCrud
        icon={IconTags}
        gradient="coral"
        title="Categorias Financeiras"
        subtitle="Classificação de contas a pagar/receber (ex: Aluguel, Vendas, Salários)"
        endpoint="financial-categories"
        addLabel="Nova categoria"
        columns={[
            { key: 'name', label: 'Nome', type: 'text', required: true },
            {
                key: 'type',
                label: 'Tipo',
                type: 'select',
                default: 'expense',
                options: [
                    { value: 'revenue', label: 'Receita' },
                    { value: 'expense', label: 'Despesa' }
                ]
            },
            { key: 'parent', label: 'Categoria pai', type: 'select', optionsSource: 'self' },
            { key: 'is_active', label: 'Ativo', type: 'checkbox', default: true }
        ]}
    />
);

export default FinancialCategories;
